import logo from '../assets/logo.png';

function Header({ mobileMenuOpen, onMenuToggle, onNavigate }) {
  return (
    <header className={`site-header ${mobileMenuOpen ? 'is-open' : ''}`}>
     <div className="brand">
  <img className="brand-logo" src={logo} alt="Chinatao" />
</div>

<nav className="main-nav" aria-label="Главное меню">
  <button type="button" onClick={() => onNavigate('services')}>Услуги</button>
  <button type="button" onClick={() => onNavigate('process')}>Процесс</button>
  <button type="button" onClick={() => onNavigate('proof')}>Почему мы</button>
  <button type="button" onClick={() => onNavigate('contact')}>Контакты</button>
</nav>

<button className="header-cta" type="button" onClick={() => onNavigate('contact')}>
  Заявка
</button>

<button
  className="menu-button"
  type="button"
  aria-label="Открыть меню"
  onClick={onMenuToggle}
>
  <span />
  <span />
  <span />
</button>
    </header>
  );
}

export default Header;